module.exports = __webpack_public_path__ + "media/images/athletes/3560-eb130e9d3823700ec032d6748aa0178c.png";